import { defaultLocale } from '@/i18n';

export const systemIsSupportingIntl = typeof Intl !== 'undefined';

export function getSystemLocale() {
  if (!systemIsSupportingIntl) return defaultLocale;

  return new Intl.DateTimeFormat().resolvedOptions().locale.slice(0, 2);
}
